import { Component, OnInit, ViewContainerRef, OnDestroy, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Globals } from '../../../globals';
import {
    AuthService,
    FacebookLoginProvider,
    GoogleLoginProvider,
    SocialUser
} from 'angular5-social-login';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';

@Component({
    selector: 'app-fmlogin',
    templateUrl: './fmlogin.component.html',
    styleUrls: ['./fmlogin.component.css']
})
export class FmloginComponent implements OnInit, OnDestroy {
    fm: FormGroup;
    fmresetPassword: FormGroup;
    modalRef: BsModalRef;
    public flags = false;
    public type = "password";
    public token: any = {
        login: "api/login",
        loginfacegoogle: "api/loginfacegoogle",
        resetpassword: "api/resetpassword"
    }

    public connect;
    public data: any = {};
    constructor(public fb: FormBuilder,
        private modalService: BsModalService, private socialAuthService: AuthService, public toastr: ToastsManager,
        vcr: ViewContainerRef, public router: Router, public globals: Globals) {
        this.toastr.setRootViewContainerRef(vcr);

        this.connect = this.globals.result.subscribe((res: any) => {
            switch (res.token) {
                case "login":
                    this.flags = false;
                    let type = (res['status'] == 1) ? "success" : (res['status'] == 0 ? "warning" : "danger");
                    this.toastr[type](res['message'], type);
                    if (res['status'] == 1) {
                        this.globals.CUSTOMER.set(res['data'], true);
                        setTimeout(() => {
                            this.router.navigate(['/']);
                            // window.location.assign(this.globals.BASE_API_URL);
                        }, 2000);
                    }
                    break;
                case 'loginfacegoogle':
                    type = (res['status'] == 1) ? "success" : (res['status'] == 0 ? "warning" : "danger");
                    this.toastr[type](res['message'], type);
                    if (res['status'] == 1) {
                        setTimeout(() => {
                            this.globals.CUSTOMER.set(res['data'], true);
                            this.router.navigate(['/']);
                        }, 500);
                    }
                    break;
                case 'resetpassword':
                    type = (res['status'] == 1) ? "success" : (res['status'] == 0 ? "warning" : "danger");
                    this.toastr[type](res['message'], type);
                    break;
                default:
                    break;
            }
        });

    }

    ngOnInit() {
        if (this.globals.CUSTOMER.check(true)) {
            this.router.navigate(['/']);
        }
        let item = this.globals.CUSTOMER.get(true);
        this.fm = this.fb.group({
            email: [item.email ? item.email : '', [Validators.required, Validators.pattern(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)]],
            password: [item.password ? item.password : '', [Validators.required]]
        })
    }
    ngOnDestroy() {
        if (this.connect) {
            this.connect.unsubscribe();
        }

    }
    onSubmit() {
        if (!this.flags) {
            this.flags = true;
            let data: any = this.fm.value;
            this.globals.send({ path: this.token.login, token: "login", data: data });
        }
    }
    public socialSignIn(socialPlatform: string) {
        let socialPlatformProvider;
        if (socialPlatform == "facebook") {
            socialPlatformProvider = FacebookLoginProvider.PROVIDER_ID;
        } else if (socialPlatform == "google") {
            socialPlatformProvider = GoogleLoginProvider.PROVIDER_ID;
        }

        this.socialAuthService.signIn(socialPlatformProvider).then(
            (response: any) => {
                console.log(socialPlatform + " sign in data : ", response);
                if (response != null) {
                    this.data.name = response.name
                    this.data.password = response.id
                    this.data.email = response.email
                    this.data.typeuser = socialPlatform
                    this.data.id_type_social = response.id
                    this.data.status = 1
                }
                this.globals.send({ path: this.token.loginfacegoogle, token: "loginfacegoogle", data: this.data });

            }
        );
    }

    resertPass(template: TemplateRef<any>) {
        this.fmresetPassword = this.fb.group({
            email: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)]],
        })
        this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
    }

    confirm(): void {
        let data = this.fmresetPassword.value
        this.globals.send({ path: this.token.resetpassword, token: "resetpassword", data: data });
        this.modalRef.hide();
    }

    decline(): void {
        this.modalRef.hide();
    }
}



// WEBPACK FOOTER //
// ./src/app/frontend/modules/fmlogin/fmlogin.component.ts